import { render, staticRenderFns } from "./ordersListDetailTable.vue?vue&type=template&id=3b6a0b7f&scoped=true"
import script from "./ordersListDetailTable.vue?vue&type=script&lang=js"
export * from "./ordersListDetailTable.vue?vue&type=script&lang=js"
import style0 from "./ordersListDetailTable.vue?vue&type=style&index=0&id=3b6a0b7f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6a0b7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b6a0b7f')) {
      api.createRecord('3b6a0b7f', component.options)
    } else {
      api.reload('3b6a0b7f', component.options)
    }
    module.hot.accept("./ordersListDetailTable.vue?vue&type=template&id=3b6a0b7f&scoped=true", function () {
      api.rerender('3b6a0b7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/components/ordersListDetailTable.vue"
export default component.exports